import type { ProjectLogosWidgetSettings } from './projectLogosWidgetSettingsSchema'
import type { Maybe } from '@/types'

export default function getDefaultValues(
  input?: Maybe<Partial<ProjectLogosWidgetSettings>>
): ProjectLogosWidgetSettings {
  return {
    darkMode: input?.darkMode ?? true,
    textAlign: input?.textAlign ?? 'center',
    duration: (input?.duration && parseInt(String(input.duration))) || 5,
  }
}
